"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.timeTranslate = void 0;

/**
 * Tencent is pleased to support the open source community by making SPA UI available.
 * Copyright (C) 2019, a Tencent company. All rights reserved.
 */

/**
 * 翻译4位数字时间，如1250 => 12:30
 * @param {string} digit - 4位数字字符串
 * @return {string} 翻译后的时间字符串
 * @private
 */
var timeTranslate = function timeTranslate() {
  var digit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (digit && digit.length === 4) {
    return digit.replace(/(\d{2})50/, '$130').replace(/(\d{2})(\d{2})/, '$1:$2');
  }

  return digit;
};

exports.timeTranslate = timeTranslate;
var _default = {
  timeTranslate: timeTranslate
};
exports["default"] = _default;